import Password from '../Password';

const PasswordExpire = () => {
  return <Password passwordExpired />;
};

export default PasswordExpire;
